import { useMutation, useQueryClient } from 'react-query';

import { uploadCustomerSignature } from 'api/visitReports/putchCustomerSignature';

interface UploadSignatureParams {
  slug: string;
  visitReportId: number;
  signatureData: string;
  documentType: 'visit' | 'period' | 'digest';
}

const usePutchCustomerSignature = () => {
  const queryClient = useQueryClient();

  const {
    isSuccess,
    mutate: putchCustomerSignature,
    isLoading,
    error,
  } = useMutation((params: UploadSignatureParams) => uploadCustomerSignature(params), {
    onSuccess: () => {
      queryClient.refetchQueries('visitDocs');
      queryClient.refetchQueries('periodDocs');
      queryClient.refetchQueries('digestDocs');
    },
    onError: err => {
      console.error('Error uploading signature:', err);
    },
  });

  return {
    isSuccess,
    putchCustomerSignature,
    isLoading,
    error,
  };
};

export default usePutchCustomerSignature;
